import React, { lazy, Suspense } from "react";
import "./ProductLayout.css";
import { useDispatch } from "react-redux";
import { addToCart } from '../../redux/state/cart/CartSlice';
import { NavLink, useNavigate } from "react-router-dom";


const LazyImage = lazy(() => import('./LazyImg'));

const ProductLayout = ({
  id,
  image,
  product_name,
  slug_to_product,
  price,
  discount,
  after_discount_price,
  columnClass = "col-12 col-sm-6 col-md-4 col-lg-3"
}) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const discountedPrice = after_discount_price;

  const product = {
    id,
    image,
    product_name,
    slug_to_product,
    discountedPrice
  };

  return (

    <div className={columnClass}>

      <div className="card product-card shadow-sm border-0 rounded-4 h-100 overflow-hidden position-relative">

        <span
          className="badge position-absolute bg-danger text-white rounded-pill px-2 py-1"
          style={{
            top: "10px",
            right: "10px",
            zIndex: 2
          }}
          title="Discount Percentage"
        >
          {discount}%
        </span>

        <Suspense fallback={<div className='text-center'>Loading...</div>}>

          <div
            className="img-card"
            onClick={() => navigate(`/product-details/${slug_to_product}`)}
            style={{ cursor: "pointer" }}
          >

            <LazyImage
              className="card-img-top product-img rounded-top-4"
              src={
                process.env.REACT_APP_IMAGEBASE_URL +
                'products/' +
                image
              }
              alt={image}
            />

          </div>

        </Suspense>

        <div className="card-body text-center d-flex flex-column">

          <h6 className="card-title fw-semibold text-ellipsis">
            {product_name}
          </h6>

          <div className="d-flex align-items-center justify-content-center gap-2 mb-3">

            <small className="text-muted text-decoration-line-through">
              ৳{price}
            </small>

            <h6 className="text-success fw-bold mb-0">
              ৳{discountedPrice}
            </h6>

          </div>

          <div className="d-flex gap-2 mt-3">

            <NavLink
              to={`/product-details/${slug_to_product}`}
              className="btn btn-gradient-aqua text-white rounded-pill flex-fill"
            >
              Buy Now
            </NavLink>

            <button
              onClick={() => dispatch(addToCart(product))}
              className="btn btn-gradient-purple text-white rounded-pill flex-fill"
            >
              Add to Cart
            </button>

          </div>

        </div>

      </div>

    </div>
  );
};

export default ProductLayout;